var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FormBuilder", {
    attrs: {
      initial: _vm.form,
      form: _vm.formDescription,
      validate: _vm.validate
    },
    on: {
      submit: function($event) {
        return _vm.$emit("submit", $event)
      },
      values: function($event) {
        return _vm.onChange($event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ data }) {
          return [
            _c(data, { tag: "component" }),
            _vm.showSubmitButton ? _c("LayoutDivider") : _vm._e(),
            _c(
              "UIButton",
              {
                style: { display: _vm.showSubmitButton ? "block" : "none" },
                attrs: { id: "fundraisersSubmitButton" }
              },
              [_vm._v(_vm._s(_vm.buttonText))]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }